import { IS_LOADING_MOSTBUYPROD_HOME } from "../../ActionType/actionTypes";

export function isLoadingMostBuyProdHome(param) {
    return (dispatch) => {
        dispatch({
            type: IS_LOADING_MOSTBUYPROD_HOME, 
            payload: {
                isLoadingMostBuyProdHome: param
            }
        })
    }
}